import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import api from '../../services/api';

// Reagenda uma visita (booking do cal.diy). bookingId = cal_booking_id / Booking.id.
export default function ReagendarVisitaModal({ isOpen, onClose, onSuccess, bookingId, nome, startTime, empreendimento }) {
  const [data, setData] = useState('');
  const [hora, setHora] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    if (isOpen && startTime) {
      // Brasília é UTC-3 fixo (sem horário de verão) — desloca e lê os componentes UTC
      const brt = new Date(new Date(startTime).getTime() - 3 * 60 * 60 * 1000);
      const iso = brt.toISOString();
      setData(iso.split('T')[0]);
      setHora(iso.split('T')[1].slice(0, 5));
      setErro(null);
    }
  }, [isOpen, startTime]);

  const salvar = async () => {
    if (!data || !hora) { setErro('Escolha data e horário'); return; }
    setSalvando(true);
    setErro(null);
    try {
      await api.patch(`/visitas/${bookingId}/reagendar`, { data_hora: `${data}T${hora}:00` });
      onSuccess?.();
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao reagendar visita');
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Reagendar Visita" size="sm">
      <div className="space-y-4">
        <div>
          <p className="text-sm font-medium text-gray-800">{nome || 'Cliente'}</p>
          {empreendimento && <p className="text-xs text-gray-500">{empreendimento}</p>}
        </div>

        {erro && (
          <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{erro}</p>
        )}

        <div>
          <label className="block text-sm font-semibold text-gray-600 mb-1">Nova data</label>
          <input
            type="date"
            value={data}
            onChange={(e) => setData(e.target.value)}
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-600 mb-1">Novo horário</label>
          <input
            type="time"
            value={hora}
            onChange={(e) => setHora(e.target.value)}
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
        </div>

        <button
          onClick={salvar}
          disabled={salvando}
          className="w-full py-2.5 bg-primary text-white rounded-lg font-semibold text-sm hover:bg-secondary disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {salvando ? 'Salvando...' : 'Confirmar novo horário'}
        </button>
      </div>
    </Modal>
  );
}
